// InlineScoreCell / TrendBars — make numeric table & list cells scannable with
// a tone-keyed score-bar (reuses .score-bar) or signed MiniBars. Encapsulates
// the band->tone rule so color stays consistent across every numeric column.

import './redesign.css';
import { MiniBars } from '../charts/Sparkline.jsx';

// >=good -> sage, >=warn -> amber, else brick. invert: lower is better.
export function bandTone(value, { good = 80, warn = 50, invert = false } = {}) {
  if (value == null || Number.isNaN(Number(value))) return 'slate';
  const v = Number(value);
  if (invert) {
    if (v <= warn) return 'sage';
    if (v <= good) return 'amber';
    return 'brick';
  }
  if (v >= good) return 'sage';
  if (v >= warn) return 'amber';
  return 'brick';
}

export function InlineScoreCell({ value, max = 100, tone, suffix = '', thresholds, ariaLabel }) {
  const numeric = Number(value);
  const pct = max ? Math.max(0, Math.min(100, (numeric / max) * 100)) : 0;
  const t = tone || bandTone(value, thresholds);
  return (
    // role="img": generic <div>s may not carry aria-label (axe
    // aria-prohibited-attr); the cell is a single graphical value readout.
    <div className="score-cell" role="img" aria-label={ariaLabel || `${value}${suffix} of ${max}`}>
      <span className="score-bar" aria-hidden>
        <i className={t} style={{ width: `${pct}%` }} />
      </span>
      <span className="score-cell__val">
        {value}
        {suffix}
      </span>
    </div>
  );
}

export function TrendBars({ values = [], tone = 'blue', ariaLabel }) {
  return <MiniBars values={values} tone={tone} ariaLabel={ariaLabel} />;
}
